import Box from '@mui/material/Box';

export default function ButtonAction({
  action = () => {},
  label = 'button',
  onNavigate,
  style = {},
  sx = {},
  btStyle = {},
}) {
  return (
    <Box style={style} sx={sx}>
      <button
        onClick={onNavigate}
        type='button'
        style={btStyle}
        className='cursor-pointer rounded-xl border-none bg-gradient-to-l from-cyan-500 to-cyan-600 py-2.5 px-6 font-semibold text-white shadow hover:shadow-cyan-500'
      >
        {label}
      </button>
    </Box>
  );
}
